import { Icon, TextField } from '@nike/eds'
import { dispatch } from 'api/redux'
import { VirtualKeyboard } from 'components/keyboard'
import { showSnackbar } from 'components/snackbar'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getAcceptableRlpnLengths } from 'utils/goodsholderContext'
import { getDCPrefix } from 'utils/rasnFamilyContext'
import { type ApiHandlerContext } from 'utils/useApiHandler'

const ACCEPTABLE_RLPN_LENGTHS = getAcceptableRlpnLengths()
const MAX_LENGTH = Math.max(...ACCEPTABLE_RLPN_LENGTHS)
const DC_PREFIX = getDCPrefix()

interface ScanRlpnRasnProps {
  openRlpnContext: ApiHandlerContext<string>
  createRasnContext: ApiHandlerContext<string>
  createFamilyRasnContext: ApiHandlerContext<string>
}

export const ScanRlpnRasn = ({ openRlpnContext, createRasnContext, createFamilyRasnContext }: ScanRlpnRasnProps) => {
  const { t } = useTranslation()

  const [error, setError] = useState('')
  const [barcode, setBarcode] = useState('')

  useEffect(() => {
    if (barcode.trim().length > MAX_LENGTH) {
      setError(t('rlpn_rasn.error'))
    } else {
      setError('')
    }
  }, [barcode])

  const keyUpHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleConfirm()
    }
  }

  const handleConfirm = () => {
    const trimmedBarcode = barcode.trim()

    if (error === '' && trimmedBarcode.length > 0) {
      const isRlpn = ACCEPTABLE_RLPN_LENGTHS.includes(trimmedBarcode.length)
      const isFamRasn = trimmedBarcode.startsWith(DC_PREFIX) && trimmedBarcode.length === 10
      console.log(DC_PREFIX)
      console.log(isFamRasn)
      const context = isRlpn ? openRlpnContext : (isFamRasn ? createFamilyRasnContext : createRasnContext)
      console.log(context)
      if (!context.isLoading) {
        context.handleApiCall(trimmedBarcode)
          .then()
          .catch(err => {
            switch (err.status) {
              case 404:
              case 423:
                dispatch(showSnackbar(err.data.message, 'error'))
                break
              default: // this case should never be reached, if so it's a bug so throw
                throw err
            }
          })
      }
      setBarcode('')
    }
  }

  return (
    <>
      <div style={{ width: '1024px' }} className={'m-auto scanTitle'}>
        <TextField
          id='barcode'
          data-testid="barcode"
          label={t('rlpn_rasn.label')}
          placeholder={t('rlpn_rasn.placeholder')}
          value={barcode}
          onChange={(e) => { setBarcode(e.currentTarget.value) }}
          autoFocus
          maxChars={MAX_LENGTH}
          hasErrors={error !== ''}
          errorMessage={error}
          onKeyUp={keyUpHandler}
          onBlur={(e) => { e.target.focus() }}
          beforeSlot={<Icon name='Scan' />}
        />
        <div className={'absolute w-full max-w-5xl'}>
          <VirtualKeyboard text={barcode} setText={setBarcode} confirm={handleConfirm} whichKeyboard={process.env.REACT_APP_KEYBOARD!} />
        </div>
      </div>
    </>
  )
}
